/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'
import connect from "react-redux/es/connect/connect"
import {withRouter} from "react-router"
import {bindActionCreators} from "redux"
import * as UsersActions from './UsersActions'
import * as UserActions from './UserActions'
import {Button, Grid, Icon} from '@scuf/common'
import Loader from '../../common/Loader'
import { DataTable } from '@scuf/datatable'
import SearchInput from '../../common/SearchInput'
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import '@scuf/datatable/honeywell-dark/theme.css'

const STATUS_FIELD = "status"
const ACTIONS_FIELD = "actions"

class Users extends React.Component {

    constructor(props) {
        super(props)

        const {profile} = this.props

        this.state = {
            filter : {
                search: '',
                sort: "lastName",
                sortOrder: 1,
            },
            readAccess: !userHasActivity(profile, [ACTIVITY_TYPES.USERS_WRITE]),
        }

        this.searchChanged = this.searchChanged.bind(this)
        this.sortChanged = this.sortChanged.bind(this)
        this.renderActions = this.renderActions.bind(this)
        this.cellClicked = this.cellClicked.bind(this)
        this.createUser = this.createUser.bind(this)
        this.renderStatus = this.renderStatus.bind(this)
    }


    createUser() {
        const {history} = this.props
        this.props.UserActions.clearState();
        const newParam = 'new'
        history.push(`/administration/users/${newParam}`)
    }

    componentDidMount() {
        this.fetchUsers()
    }

    fetchUsers() {
        this.props.UsersActions.fetchUsers(this.state.filter.search, this.state.filter.sort,
            this.state.filter.sortOrder)
    }

    searchChanged(search) {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                search: search,
            },
        }, this.fetchUsers)
    }

    sortChanged(sortData) {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                sort: sortData.sortField,
                sortOrder: sortData.sortOrder,
            },
        })
    }

    renderActions() {
        const {intl} = this.props
        return (
            <Icon name="edit" size="medium" description={intl.formatMessage({id: "admin.users.list.edit"})}/>
        )
    }

    renderStatus(data) {
        if(data.value === 'DISABLED') {
            return (
                <span><DataTable.Status className="cell-status" color="state-disabled" /><FormattedMessage id="admin.users.list.disabled" /></span>
            )
        }
        return (
            <span><DataTable.Status className="cell-status" color="state-enabled" /><FormattedMessage id="admin.users.list.enabled" /></span>
        )
    }

    cellClicked(data) {
        const {history} = this.props
        this.props.UserActions.clearState();
        history.push(`/administration/users/${data.rowData.id}`)
    }


    render() {
        const {intl, users, build} = this.props

        return (
            <div id="users-list">
                <Loader loading={users.loading}/>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={7} sWidth={12} className="user-filter" sOrder={2}>
                            <SearchInput placeholder={intl.formatMessage({id: "filter.search"})} fluid
                                         onChange={this.searchChanged}/>
                        </Grid.Column>
                        {
                            build.localAccountsDisabled !== 'true' ?
                                <Grid.Column width={5} sWidth={12} sOrder={1}>
                                    <div className="create-user-button-div">
                                        <Button
                                            type="primary"
                                            content={intl.formatMessage({id: "admin.users.create"})}
                                            disabled={this.state.readAccess}
                                            onClick={this.createUser}
                                            className="mobile-max-width-button"
                                        />
                                    </div>
                                </Grid.Column> : null
                        }
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className="datatable-mobile-x-scroll">
                                <DataTable
                                    data={users.users}
                                    reorderableColumns={true}
                                    resizeableColumns={true}
                                    sortField={this.state.filter.sort}
                                    sortOrder={this.state.filter.sortOrder}
                                    onSort={this.sortChanged}
                                    onCellClick={this.cellClicked}
                                    scrollable={true}
                                >
                                    <DataTable.Column header={intl.formatMessage({id: "admin.users.list.userName"})} field="userName" sortable={true}/>
                                    <DataTable.Column header={intl.formatMessage({id: "admin.users.list.email"})} field="email" sortable={true}/>
                                    <DataTable.Column header={intl.formatMessage({id: "admin.users.list.firstName"})} field="firstName" sortable={true}/>
                                    <DataTable.Column header={intl.formatMessage({id: "admin.users.list.lastName"})} field="lastName" sortable={true}/>
                                    <DataTable.Column header={intl.formatMessage({id: "admin.users.list.state"})} field={STATUS_FIELD} sortable={false} renderer={this.renderStatus}/>
                                    <DataTable.Column header="" field={ACTIONS_FIELD} sortable={false} renderer={this.renderActions} initialWidth={80}/>
                                </DataTable>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        build: state.version.build,
        users: state.users,
        profile: !state.security ? null : state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        UsersActions: bindActionCreators(UsersActions, dispatch),
        UserActions: bindActionCreators(UserActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Users)))